<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" routerLink="/employees">{{ utils.getLangTerm('employees.plural', 'Employees') }}</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">
        <button *ngIf="canCreate" mat-raised-button color="primary" class="m-1 mr-2" id="add" (click)="onAddEmployee()">
          <mat-icon>add</mat-icon>
          Add {{ utils.getLangTerm('employees.singular', 'Employee') }}
        </button>

        <ng-container *ngIf="canCreate">
          <mat-menu #appImportMenu="matMenu">
            <button mat-menu-item routerLink="/employees/importer" matTooltip="Click this button to mass import {{ utils.getLangTerm('employees.plural', 'Employees') }} from a CSV file.">
              <mat-icon>cloud_upload</mat-icon> {{ utils.getLangTerm('employees.plural', 'Employees') }}
            </button>

            <!--button mat-menu-item routerLink="/employees/docs-importer" matTooltip="Click this button to mass import {{ utils.getLangTerm('employees.plural', 'Employees') }} Documents from a CSV file.">
              <mat-icon>cloud_upload</mat-icon> Documents
            </button-->
          </mat-menu>

          <button mat-raised-button class="m-1 mr-2" [matMenuTriggerFor]="appImportMenu" matTooltip="Use this menu to do imports." style="min-width: 150px">
            <mat-icon>cloud_upload</mat-icon> Import
          </button>
        </ng-container>

        <ng-container *ngIf="canView || canDelete">
          <mat-menu #appMenu="matMenu">
            <ng-container *ngIf="canView || canDelete">
              <button mat-menu-item (click)="listDataSource.selectAllToggle()">
                <mat-icon *ngIf="listDataSource.isAllSelected()"> clear_all</mat-icon><mat-icon *ngIf="!listDataSource.isAllSelected()">select_all</mat-icon>
                {{ listDataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
              </button>
            </ng-container>

            <ng-container *ngIf="canView">
              <button mat-menu-item (click)="onExport('csv')">
                <mat-icon>cloud_download</mat-icon> Export {{ listDataSource.selection.hasValue() ? '(' + listDataSource.selection.selected.length + ') Selected' : 'All' }} to CSV
              </button>

              <button mat-menu-item (click)="onTrainingDocsExport('csv')">
                <mat-icon>cloud_download</mat-icon> Export {{ listDataSource.selection.hasValue() ? '(' + listDataSource.selection.selected.length + ') Selected' : 'All' }} Training/Competency Documents to CSV
              </button>

              <button mat-menu-item (click)="onTrainingDocsExport('pdf')">
                <mat-icon>cloud_download</mat-icon> Export {{ listDataSource.selection.hasValue() ? '(' + listDataSource.selection.selected.length + ') Selected' : 'All' }} Training/Competency Documents to PDF
              </button>
            </ng-container>

            <button *ngIf="canComposeMessages" mat-menu-item (click)="composeNewMessage()">
              <mat-icon>send</mat-icon>
              Send Message {{ listDataSource.selection.hasValue() ? 'to (' + listDataSource.selection.selected.length + ') Selected' : '(0)' }}
            </button>

            <button *ngIf="canEditRbacRoles" mat-menu-item (click)="onAssignRbacRolesToSelected()" [disabled]="!listDataSource.selection.hasValue()">
              <mat-icon>admin_panel_settings</mat-icon>
              Assign RBAC Roles to {{ listDataSource.selection.hasValue() ? '(' + listDataSource.selection.selected.length + ') Selected' : 'Selected' }}
            </button>

            <button *ngIf="canDelete" mat-menu-item (click)="onDeleteSelected()" [disabled]="!listDataSource.selection.hasValue()">
              <mat-icon>delete</mat-icon> Delete Selected
            </button>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu" matTooltip="Use this menu to select/deselect and/or export {{ utils.getLangTerm('employees.plural', 'Employees') }}." style="min-width: 150px">
            <mat-icon>more_vert</mat-icon>
            List Menu/Export
          </button>
        </ng-container>

      </span>

      <form *ngIf="canView" class="form-inline mx-1 my-0" (ngSubmit)="listDataSource.getData(true)">
        <input
          class="form-control ml-0 mr-2 my-1"
          type="search"
          [(ngModel)]="listDataSource.search"
          name="search"
          placeholder="Search {{ utils.getLangTerm('employees.plural', 'Employees') }}"
          aria-label="Search"
          id="search-input"
          matTooltip="Search for {{ utils.getLangTerm('employees.plural', 'Employees') }} by name, email address, mobile number or address." />

        <button
          mat-raised-button
          color="secondary"
          type="submit"
          class="mx-0 my-1"
          id="search-button"
          matTooltip="Click this button to run the current search.">
          <mat-icon>search</mat-icon> Search
        </button>
      </form>

    </div>
  </nav>

  <div class="alert alert-warning m-2" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view {{ utils.getLangTerm('employees.plural', 'Employees') | lowercase }}.
    <span *ngIf="canCreate">You can still create new {{ utils.getLangTerm('employees.plural', 'Employees') | lowercase }} using the button above.</span>
    <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
  </div>

  <div class="mat-elevation-z8 scroll-box" *ngIf="canView">
    <table mat-table [dataSource]="listDataSource" matSort matSortActive="contact_person" matSortDirection="asc" matSortDisableClear>

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox (change)="$event ? listDataSource.selectAllToggle() : null"
            [checked]="listDataSource.selection.hasValue() && listDataSource.isAllSelected()"
            [indeterminate]="listDataSource.selection.hasValue() && !listDataSource.isAllSelected()"
            matTooltip="Toggle selecting all {{ utils.getLangTerm('employees.plural', 'Employees') }} on this page">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
            (change)="$event ? listDataSource.selection.toggle(row.id) : null"
            [checked]="listDataSource.selection.isSelected(row.id)"
            matTooltip="Toggle selecting '{{row.contact_person}}' for deletion'">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="icons">
        <th mat-header-cell *matHeaderCellDef>Status Icons</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon matTooltip="" *ngIf="element.courses_count > 0"
            [matTooltip]="element.courses_count_completed + '/' + element.courses_count + ' Inductions Completed.'"
            [ngStyle]="{'color': (element.courses_count_completed > 0 ? (element.courses_count_completed < element.courses_count ? 'orange' : 'green') : 'red')}">
            {{ element.courses_count_completed > 0 ? 'done_outline' : 'clear' }}
          </mat-icon>

          <mat-icon matTooltip="Connected to the {{ utils.getAppName() }} mobile app{{ element.version ? (', using version ' + element.version) : ''}}." *ngIf="element.device_id">
            phonelink_setup
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="contact_person">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by full name">
          Full Name
        </th>
        <td mat-cell *matCellDef="let element">
          <a (click)="onUserPublicView(element.hash)"
             matTooltip="View User Public Profile">
            {{ element.contact_person }}
          </a>
          <!-- Blocked by support (SC-3089). The tooltip shows the note the support team chose to share. -->
          <span
            class="badge badge-danger ml-1"
            *ngIf="element.is_blocked"
            [matTooltip]="element.blocked_client_note || ('This user has been blocked by ' + utils.getAppName() + ' support.')">
            Blocked
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by email address">
          Email Address
        </th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by {{ utils.getLangTerm('users.list.mobile', 'Mobile Number') }}">
          {{ utils.getLangTerm('users.list.mobile', 'Mobile Number') }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.mobile }}</td>
      </ng-container>

      <ng-container matColumnDef="trade">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by job title">
          Job Title
        </th>
        <td mat-cell *matCellDef="let element">{{ element.trade }}</td>
      </ng-container>

      <ng-container matColumnDef="rbac_roles">
        <th mat-header-cell *matHeaderCellDef>
          RBAC Roles
        </th>
        <td mat-cell *matCellDef="let element">
          <!-- Super admin (support) users are not managed via account RBAC roles. Show a single,
               non-removable "Support" chip instead of role chips. -->
          <mat-chip-set *ngIf="element.is_sitesoft_admin">
            <mat-chip matTooltip="This is a {{ utils.getAppName() }} support user. Their access is managed by {{ utils.getAppName() }}, not by account RBAC roles.">
              Support
            </mat-chip>
          </mat-chip-set>

          <ng-container *ngIf="!element.is_sitesoft_admin">
            <mat-chip-set>
              <mat-chip *ngFor="let role of element.rbac_roles">
                @if (isPartnerRole(role)) {
                  <mat-icon matChipAvatar [matTooltip]="'Managed by ' + utils.getAppName()">lock</mat-icon>
                }
                {{ role.name | titlecase }}
                <button matChipRemove *ngIf="canEditRbacRoles && !rowLocked(element) && !rbac.partnerLockApplies(isPartnerRole(role))" (click)="onUnlinkRbacRole(element.id, role)"
                  [attr.aria-label]="'Unlink ' + role.name + ' role'"
                  matTooltip="Unlink this role">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            </mat-chip-set>
            <span class="text-muted" *ngIf="!element.rbac_roles || element.rbac_roles.length === 0">No roles</span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef>
          Notes
        </th>
        <td mat-cell *matCellDef="let element">{{ element.pivot?.notes }}</td>
      </ng-container>

      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by role">
          Date Enrolled
        </th>
        <td mat-cell *matCellDef="let element">{{ (element.date_created * 1000) | timezoneConvertMedium }}</td>
      </ng-container>

      <ng-container matColumnDef="date_created_UTC">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by role">
          Date Enrolled(UTC)
        </th>
        <td mat-cell *matCellDef="let element">{{ (element.date_created * 1000) | timezoneConvertUTCMedium }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="160"></th>
        <td mat-cell *matCellDef="let element">
          <!-- Super admin (support) users may only be managed from an internal account. -->
          <button type="button" mat-button [routerLink]="'/employees/' + element.id + '/details'"
            *ngIf="canEdit && (!element.is_sitesoft_admin || app.account?.is_internal)">
            <!-- Partner users open read-only. -->
            {{ rowLocked(element) ? 'View' : 'Edit' }}
          </button>

          @if (canDelete && (!element.is_sitesoft_admin || app.account?.is_internal) && !rowLocked(element)) {
            <button type="button" mat-button (click)="onDelete(element.id)">
              Delete
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [length]="listDataSource?.total | async" [pageSize]="listDataSource.limit" [pageSizeOptions]="listDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
  </div>
</div>
